export const LinkSocialLinkedin = 'https://www.linkedin.com/in/warp-techical-495512261';
export const LinkSocialFacebook = 'https://www.facebook.com/warppipetrading';
export const LinkSocialTelegram = 'https://t.me/stewietran';
export const LinkBookCall = 'https://calendly.com/warppipe/30min';
export const LinkPortfolio =
  'https://drive.google.com/file/d/1l3Ixsgt59NHxELwL7pLXWMBdrH4YQ9ml/view?usp=sharing';
export const LinkSubmitProject =
  'https://docs.google.com/forms/d/e/1FAIpQLSdve4EKhTcFGqVzVbsesI5rtFmxd7ufJBD7aqRwndmZbp2Qgw/viewform?usp=dialog';
